export class BaseEntity {
  id: string;
  docType: string;
  modifiedTime: Date;
  modifiedByPersonId: string;
  revision: string;
}
